<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true" style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='未排班学员' url='/cycle/plan/stunoplan'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <!--begin: Search Form -->
        <div class="m-form m-form--label-align-right">
          <SearchNormalText v-model='condition.stuname' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.stuno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.stusec' label='科室' :dictid='this.$utils.DictEnum.section'></ZPGLSearchDictItemSelect>
          <ZPGLSearchDictItemSelect v-model='condition.stuspec' label='专业' :dictid='this.$utils.DictEnum.specialty'></ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">培养年限：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.stueduyear" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in trainingyearOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <ZPGLSearchDictItemSelect v-model='condition.stuyear' label='届别' :dictid='this.$utils.DictEnum.stuyear'></ZPGLSearchDictItemSelect>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
          <SearchButton :url="searchUrl" ref="btnSearch"></SearchButton>
          <el-button type="success" icon="el-icon-refresh" @click="dialogFormVisible = true">自动排班</el-button>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%;" size="medium">
            <el-table-column prop="StuName" label="姓名">
            </el-table-column>
            <el-table-column prop="StuNo" label="工号">
            </el-table-column>
            <el-table-column prop="SectionName" label="科室">
            </el-table-column>
            <el-table-column prop="SpecialityName" label="专业">
            </el-table-column>
            <el-table-column prop="UserTypeName" label="用户类型">
            </el-table-column>
            <el-table-column prop="StuEduYearName" label="培养年限">
            </el-table-column>
            <el-table-column prop="StuYearName" label="届别">
            </el-table-column>
            <el-table-column prop="StandardName" label="规范名称">
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="condition.currentPage"
              :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="condition.recordCount">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="排班开始时间" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="开始时间" label-width="120px">
          <el-input v-model="form.begindate" placeholder="请输入排班开始时间,参考格式:2000-01-01"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="AutoPlan()" v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name: 'StuNoPlan',
    data() {
      return {
        condition: {
          username: '',
          rolelevel: '',
          secid: '',
          stuname: '',
          stusec: '',
          stuno: '',
          stuspec: '',
          stueduyear: '',
          stuyear: '',
          token: '',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true
        },
        trainingyearOptions: [{
          value: '1',
          label: '一年生'
        }, {
          value: '2',
          label: '两年生'
        }, {
          value: '3',
          label: '三年生'
        }, {
          value: '4',
          label: '往届生'
        }],
        form: {
          begindate: ''
        },
        dialogFormVisible: false,
        tableData: null,
        searchUrl: this.$utils.Url.zpgl + '/api/APIStu/StuNoPlan',
        loading: true,
        fullscreenLoading: false
      }
    },
    methods: {
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.changePageCoreRecordData()
        this.condition.currentPage = val
        this.$refs.btnSearch.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.changePageCoreRecordData()
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.$refs.btnSearch.Search()
      },
      AutoPlan: function() {
        if (this.form.begindate == '') {
          this.$message({
            message: '排班开始时间不能为空',
            type: 'error'
          })
        } else {
          var result = this.form.begindate.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);
          if (result == null) {
            this.$message({
              message: '排班开始时间格式错误,参考格式:2000-01-01',
              type: 'error'
            })
          } else {
            var args = {
              token: this.form.token,
              username: this.condition.username,
              rolelevel: this.condition.rolelevel,
              secid: this.condition.secid,
              stuname: this.condition.stuname,
              stusec: this.condition.stusec,
              stuno: this.condition.stuno,
              stuspec: this.condition.stuspec,
              stueduyear: this.condition.stueduyear,
              stuyear: this.condition.stuyear,
              begindate: this.form.begindate
            }
            this.fullscreenLoading = true
            var that = this
            this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIStu/AutoPlan', args, function(data) {
              if(data.Code === 0){
                that.$message({
                  message: '自动排班成功',
                  type: 'success'
                })
                that.$refs.btnSearch.Search()
                that.dialogFormVisible = false
              }else{
                that.$message({
                  message: '操作失败',
                  type: 'error'
                })
              }
              that.fullscreenLoading = false
            }, function(){
              that.$message({
                message: '操作失败',
                type: 'error'
              })
              that.fullscreenLoading = false
            },  function(){
              that.$message({
                message: '操作失败',
                type: 'error'
              })
              that.fullscreenLoading = false
            }, null)
          }
        }
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      this.condition.secid = sessionStorage.getItem('secid')
      this.$refs.btnSearch.Search()
    }
  }
</script>

<style scoped="scoped">
  /deep/.el-table .cell {
    line-height: 20px;
  }
</style>
